<template>
  <div>
    <div class="row mt-3">
      <div class="col">
        <Speaker submission_id="0" area="login" textkey="info"></Speaker>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col col-sm-4">
        <a type="button" class="btn btn-secondary btn-block btn-lg" :href="getLoginUrl()">
          <icon :icon="['fad', 'sign-in-alt']"/>&nbsp;<Speaker submission_id="0" area="login" textkey="button"></Speaker>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        username: '',
        password: '',
        showError: false
      };
    },
    computed: mapState([
      'login'
    ]),
    created() {
    },
    methods: {
      getLoginUrl() {
        return process.env.VUE_APP_AUTH_URL + 'application/' + process.env.VUE_APP_AUTH_KEY;
      }
    }
  }

</script>

<style scoped>

</style>
